import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=80f3c6f2&"
import script from "./DetailsPage.vue?vue&type=script&lang=ts&"
export * from "./DetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports